// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ciPS","signatureBlock":"Footer_signatureBlock__2S3jp","signature":"Footer_signature__1sgkY"};